import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Proptypes from 'prop-types';

function PrivateRoute(props) {
  const {
    component: Component,
    newIsAdmin = false,
    appLoaded,
    isAuthenticated = false,
    profile = {},
    publicRedirect = '/',
    privateRedirect = '/my-profile',
    supervisorRedirect = '/profiles',
    adminRedirect = '/dashboard',
    allow,
    allowAttr,
    newUserType,
    ...rest
  } = props;

  const getAllowedComponent = (routeProps) => {
    const component = <Component {...props} {...routeProps} />;
    if (allowAttr) {
      if (profile[allowAttr] === true) {
        return component;
      }
    }
    if (!allow || !allow.length) {
      // Se allowType è vuoto, consenti l'accesso all'utente autenticato, qualunque sia il tipo
      return component;
    }
    if (Array.isArray(allow) && allow.includes(profile.type)) {
      // Se allowType non è vuoto, consenti l'accesso all'utente autenticato il cui tipo coincide con i tipi permessi
      return component;
    }

    return (
      <Redirect
        push={false}
        to={{
          pathname: newIsAdmin
            ? newUserType === 'SUPER_ADMIN'
              ? adminRedirect
              : supervisorRedirect
            : privateRedirect,
          state: { from: props.location },
        }}
      />
    );
  };

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        return isAuthenticated ? (
          appLoaded ? (
            getAllowedComponent(routeProps)
          ) : (
            ''
          )
        ) : (
          <Redirect
            push={false}
            to={{
              pathname: publicRedirect,
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
}

PrivateRoute.propTypes = {
  component: Proptypes.func.isRequired,
  isAuthenticated: Proptypes.bool,
  allow: Proptypes.arrayOf(Proptypes.string),
};

export default PrivateRoute;
